import React, { CSSProperties, useState } from "react";

import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

import useConditions from "../../hooks/useConditions";
import Condition, { enum_conditional } from "../../models/conditions/Condition";
import { DatabaseTable } from "../../models/BaseTable";
import { useRowSelector } from "../../store/Hooks";

const ConditionalBar = styled("div")(({ theme }) => ({
  backgroundColor: "#FFF0A5",
  cursor: "pointer",
}));

interface ConditionBarProps {
  table: typeof DatabaseTable;
  tableID: any;
  sx?: CSSProperties;
}

interface ConditionBarState {
  directRootID: number | undefined;
  parentRootID: number | undefined;
  showConditional: boolean;
}

const ConditionBar = (props: ConditionBarProps) => {
  const { getConditions } = useConditions();
  const [state, setState] = useState<ConditionBarState>({
    directRootID: undefined,
    parentRootID: undefined,
    showConditional: false,
  });
  const directRoot = useRowSelector(Condition, state.directRootID as number);
  const parentRoot = useRowSelector(Condition, state.parentRootID as number);

  const directConditional =
    typeof directRoot === "undefined" ? "" : directRoot.toString();
  const parentConditional =
    typeof parentRoot === "undefined" ? "" : parentRoot.toString();

  const sx: CSSProperties = typeof props.sx === "undefined" ? {} : props.sx;
  if (state.showConditional) {
    sx.height = "auto";
  } else {
    sx.height = 8;
  }

  const handleClick = async () => {
    if (state.showConditional) {
      setState({
        ...state,
        showConditional: false,
      });
    } else {
      const conditions = await getConditions(props.table, props.tableID);
      // Make a temporary condition with parent conditions as its children
      let parentRoot: Condition | null = null;
      if (conditions.parentConditions.length > 0) {
        parentRoot = Condition.createInstance({
          conditional: enum_conditional.and,
        }) as Condition;
        conditions.parentConditions.forEach((condition) => {
          if (condition.parent_condition_id  === null && parentRoot !== null) {
            parentRoot.addChild(condition);
          }
        });
      }
      // Find root of direct conditions
      let set: number | undefined;
      if (conditions.directConditions.length > 0) {
        set = conditions.directConditions[0].set_condition_id ;
      }
      setState({
        directRootID: set,
        parentRootID: parentRoot?.id,
        showConditional: true,
      });
    }
  };
  return (
    <ConditionalBar sx={sx} onClick={handleClick}>
      {state.showConditional && (
        <>
          <Typography fontStyle={"italic"}>{parentConditional}</Typography>
          {parentConditional !== "" && <Typography>AND</Typography>}
          <Typography>{directConditional}</Typography>
        </>
      )}
    </ConditionalBar>
  );
};

export default ConditionBar;
